const pad = (n) => String(n).padStart(2, '0')

// Formats a date as "dd-mm-yyyy HH:mm:ss" (e.g. 12-06-2026 16:07:34) in local
// time. Accepts a Date, ISO string or epoch ms; returns "-" for empty/invalid.
export const formatDateTime = (value) => {
  if (value == null || value === '') return '-'
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return '-'
  const date = `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  return `${date} ${time}`
}
